interface IFileIdentifier {

}
type SiteElementUploadFileProgress = 'succeeded' | 'inprogress' | 'failed';

class SiteElementUpload
    extends QueryElement<HTMLElement> {

    private readonly _name: string;
    private readonly _dropEvent: (data: QueryUploadFile) => Promise<void>;
    private readonly _drop: QueryUpload;
    private readonly _files: IQueryElement;
    private readonly _provider: string;
    private readonly _input: IQueryElement;

    constructor(element: HTMLElement) {
        super(element);

        let provider = this.getAttr("data-provider");
        let name = this.getAttr("data-name");

        if (provider === null || name === null)
            throw "No information about provider/name!";

        this._name = name;
        this._provider = provider;

        this._input = QueryElement.QueryElement("input")
            .setAttr("type", "file")
            .setAttr("multiple", "multiple")
            .appendTo(this);
           
        this._drop = new QueryUpload(document.createElement("div"), this._input)
            .addClass("drop")
            .setHtml(`<i>cloud_upload</i>Sleep uw bestanden hierheen om te uploaden.`)
            .appendTo(this);
        this._drop.on("dragover", () => this.addClass("drag"));
        this._drop.on("dragleave", () => this.removeClass("drag"));
        this._drop.on("drop", () => this.removeClass("drag"));
        
        this._files = QueryElement.QueryElement("div")
            .addClass("files")
            .appendTo(this);
        
        this._dropEvent = this._drop.dropEvent.on(async (a) => { await this.addFile(a); });
    }

    getName() {
        return this._name;
    }

    async addFile(file: QueryUploadFile) {
        await new SiteLabelUploadFile(this, file, this._provider)
            .appendTo(this._files)
            .upload();
    }
    async remove(removeInner = true) {
        await super.remove(removeInner);

        // Cleanup event
        this._drop.dropEvent.off(this._dropEvent);
    }
}
class SiteLabelUploadFile
extends QueryElement<HTMLElement> {

    private readonly _icon: IQueryElement;
    private readonly _file: QueryUploadFile;
    private readonly _provider: string;
    private readonly _element: SiteElementUpload;
    private readonly _input: QueryElement<HTMLElement>;
    private _id: any;
    private _state: SiteElementUploadFileProgress;

    public get id() { return this._id; }
    public get state() { return this._state; }

    constructor(element: SiteElementUpload, file: QueryUploadFile, provider: string) {
        super(document.createElement("div"));

        this._element = element;
        this._file = file;
        this._provider = provider;
        this._state = "failed";

        this._icon = QueryElement.QueryElement("i")
            .setHtml(SiteLabelUploadFile.mimeToIcon(file.type));
        
        this._input = QueryElement.QueryElement("input")
            .setAttr("type", "text")
            .setAttr("name", `${this._element.getName()}[]`);
        
        let title = QueryElement.QueryElement("div")
            .addClass("title")
            .setHtml(file.name);
        
        this.addClass("file")
            .append(this._icon)
            .append(this._input)
            .append(title);
    }
    async upload() {
        this._state = "inprogress";

        if(this._file instanceof QueryUploadFileUpload) {
            try {
                let response = await this._file.upload(
                    {
                        provider: this._provider
                    }
                );

                // 200 OK with no JSON:
                if(response === undefined)
                    throw "Not recieved the information.";

                this._id = response.id;
                this._input.setVal(response.id.objectName);

                if (response.preview !== undefined) {
                    this.setPreview(response.preview);
                }
                
                this._state = "succeeded";
                this.addClass("success");
            } catch(e) {
                this._state = "failed";
                this.addClass("failed");
            }
        }
    }

    setPreview(preview: string) {
        let style = this._icon.style();

        if (style !== undefined) {
            style.backgroundImage = `url(${preview})`;
            this._icon.setHtml("");
        }
    }

    private static mimeToIcon(mime: string) {
        if (mime.startsWith("image/"))
            return "image";
        else if (mime.startsWith("video/"))
            return "movie";
        else if (mime.startsWith("audio/"))
            return "audiotrack";
        else if (mime.startsWith("application") || mime.startsWith("text"))
            return "description";
        
        return "attachment";
    }
}